// Meta label helpers for documentation entries ("Video · 0:48" / "4 Min. Lesezeit")

export const formatVideoDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const rest = seconds % 60;
  return `${minutes}:${String(rest).padStart(2, '0')}`;
};

export const formatEntryMeta = (entry, t) => {
  if (entry.contentType === 'video' && entry.videoDurationSeconds != null)
    return `${t('Video')} · ${formatVideoDuration(entry.videoDurationSeconds)}`;
  if (entry.readTimeMinutes != null)
    return t('{{n}} min. read', { n: entry.readTimeMinutes });
  return '';
};
